export default "__VITE_ASSET__93dc96e1__"